import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3708beaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full headerSize border-b bg-gray-100 dark:bg-dark-400 dark:border-dark-200" }
const _hoisted_2 = { class: "h-full text-center flex px-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (course) => {
        return (_openBlock(), _createElementBlock("button", {
          key: course.serial,
          class: _normalizeClass(["px-8 my-2 mx-1 rounded cursor-pointer focus:outline-none", {
          'bg-gray-200 dark:bg-dark-10 text-arena-lighter':
            course.serial == _ctx.dashboardModalStatePresenter.courseSerial.value
        }]),
          onClick: ($event: any) => (_ctx.click(course.id, course.serial))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(course.shortName), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}